import React from 'react';

const team = [
  {
    title: 'Platform leadership',
    detail:
      'Strategic direction, product purpose, growth framing, and long-term platform architecture.',
  },
  {
    title: 'Business development',
    detail:
      'Area-based provider relationships, onboarding support, and local market development.',
  },
  {
    title: 'Audit and governance',
    detail:
      'Dispute pathways, escalation discipline, financial trust, and operational oversight.',
  },
  {
    title: 'Product and engineering',
    detail:
      'Frontend, backend, data, integration, and workflow implementation across the HnB platform.',
  },
  {
    title: 'Support and experience',
    detail:
      'Customer and provider support, issue response, and service-quality feedback loops.',
  },
  {
    title: 'AI and innovation',
    detail:
      'Preview generation, recommendation logic, and future AI experience evolution.',
  },
];

export default function TeamPage() {
  return (
    <main style={{ background: '#f8fafc', color: '#0f172a', minHeight: '100vh' }}>
      <section
        style={{
          padding: '72px 24px 56px',
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
          }}
        >
          <p
            style={{
              margin: 0,
              color: '#4f46e5',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              fontSize: '0.9rem',
            }}
          >
            Team
          </p>
          <h1 style={{ margin: 0, fontSize: '3rem', lineHeight: 1.08, maxWidth: '11ch' }}>
            The people and functions behind HnB
          </h1>
          <p
            style={{
              margin: 0,
              color: '#475569',
              lineHeight: 1.8,
              fontSize: '1.05rem',
              maxWidth: '72ch',
            }}
          >
            Your earlier HnB discussions described public team visibility for HnB staff,
            governance structure, and oversight roles such as BDO, auditors, business
            heads, and leadership functions.
          </p>
        </div>
      </section>

      <section style={{ padding: '56px 24px 72px' }}>
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '18px',
          }}
        >
          {team.map((item) => (
            <div
              key={item.title}
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '18px',
                padding: '22px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <h2 style={{ margin: 0, fontSize: '1.1rem' }}>{item.title}</h2>
              <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.75 }}>{item.detail}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}